import Image from 'next/image';
import type { Control, Path, RegisterOptions } from 'react-hook-form';
import { useController } from 'react-hook-form';

import {
	RatingContainer,
	RatingItem,
	RatingItemRadio,
	RatingItemTitle,
} from './styles';

const rating = {
	1: 'Bad',
	2: 'Poor',
	3: 'Average',
	4: 'Good',
	5: 'Excellent',
};

type RatingFieldProps<TFormValues extends Record<string, unknown>> = {
	name: Path<TFormValues>;
	control: Control<TFormValues>;
	rules?: RegisterOptions<TFormValues, Path<TFormValues>>;
	disabled?: boolean;
};

export const RatingField = <TFormValues extends Record<string, unknown>>({
	name,
	control,
	rules,
	disabled,
}: RatingFieldProps<TFormValues>) => {
	const {
		field: { onChange, value, ref },
	} = useController({
		name,
		control,
		rules,
	});

	return (
		<RatingContainer>
			{Object.entries(rating).map(([key, ratingValue]) => (
				<RatingItem key={key}>
					<RatingItemRadio
						type="radio"
						value={key}
						checked={value === key}
						onChange={() => onChange(key)}
						disabled={disabled}
						ref={ref}
						name={name}
					/>
					<Image
						src={`/assets/rating/${key}.svg`}
						width={56}
						height={56}
						alt={ratingValue}
					/>
					<RatingItemTitle size="S" color="semi-transparent">
						{ratingValue}
					</RatingItemTitle>
				</RatingItem>
			))}
		</RatingContainer>
	);
};
